// extracted by mini-css-extract-plugin
export var defaultFont = "index-module--default-font--PJC8D";
export var fontWeight500 = "index-module--font-weight-500--xD4+4";
export var codeFont = "index-module--code-font--+ba0w";
export var textGreen = "index-module--text-green--7ikxx";
export var clearButtonStyles = "index-module--clear-button-styles--UAhTH";
export var new_section = "index-module--new_section--vV-wh";